import { render, staticRenderFns } from "./TemporaryAssistance.vue?vue&type=template&id=55056d16"
import script from "./TemporaryAssistance.vue?vue&type=script&lang=js"
export * from "./TemporaryAssistance.vue?vue&type=script&lang=js"
import style0 from "./TemporaryAssistance.vue?vue&type=style&index=0&id=55056d16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports